export default [
  {
    path: '/DeviceManagement',
    component: () => import('@/components/Layer.vue'),
    children: [
      {
        path: '/DeviceManagement/',
        name: 'DeviceManagement',
        component: () => import('@/views/Management/DeviceManagement.vue'),
        meta: {
          prev: 'goHome'
        }
      }
    ]
  }
]
